module.exports = __webpack_public_path__ + "static/dcom1-995366ecf3157699ee9dac701d07bf6f.png";